import { ProductPerformanceItem } from '@/types/report-type';
import { ProductReport } from '../product/report/model/product-report';

// Chart colors constant
export const CHART_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// Channel name mapping
const CHANNEL_NAME_MAP: Record<string, string> = {
    'facebook_comment': 'auto_comment',
    'facebook_chat': 'auto_chat',
    'facebook_sale_chat': 'drag_drop_chat',
    'facebook_sale_comment': 'drag_drop_comment',
    'unknown': 'manual',
};

// Helper function to map channel names to user-friendly names
export function mapChannelName(channel: string): string {
    const normalizedChannel = channel.toLowerCase();
    return CHANNEL_NAME_MAP[normalizedChannel] || channel;
}

// Helper function to transform API product data to ProductReport format
export function transformProductData(products: ProductPerformanceItem[]): ProductReport[] {
    return products.map((product, index) => ({
        name: product.productName,
        quantity: product.totalQuantitySold,
        revenue: product.totalRevenue,
        rank: index + 1,
    }));
}

// Helper function to get initial date range (today)
export function getInitialDateRange(): { fromDate: string; toDate: string } {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const formatDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return {
        fromDate: formatDate(today),
        toDate: formatDate(today),
    };
}
